import { Injectable } from '@angular/core';
import { CommonInfoService } from '../../../../cart-process/common-info.service';
import MarkerClusterer from '@googlemaps/markerclustererplus';

declare const google: any;

@Injectable()
export class PosPrecartPickupService {

  map: google.maps.Map;
  markerClusterer: MarkerClusterer;

  private initMap = false;

  readonly options: any = {
    target: 'delivery-map',
    mapOptions: {
      center: {lat: 52.243000, lng: 20.970002},
      minZoom: 7,
      maxZoom: 19,
      zoom: 14,
      mapTypeControl: false,
      scrollwheel: false,
      fullscreenControl: false,
      streetViewControl: false,
    },
    clusterOptions: {
      imagePath: window['themeResourcePath'] + '/images/maps/m',
      gridSize: 100,
      styles: [{
        height: 56,
        width: 56,
        url: window['themeResourcePath'] + `/images/maps/marker-pos-number${this.commonInfo.isVirginBrand ? '-virgin' : ''}.png`
      }],
      clusterClass: 'custom-clustericon'
    }
  };

  constructor(
    private commonInfo: CommonInfoService
  ) {
  }

  loadScript(): any {
    return new Promise((resolve, reject) => {
      let node = document.createElement('script');
      node.src = `https://maps.googleapis.com/maps/api/js?key=${window['GOOGLE_API_KEY']}`;
      node.async = true;
      node.defer = true;
      node.onload = resolve;
      node.onerror = reject;
      document.getElementsByTagName('body')[0].appendChild(node);
    });
  }

  initialMap(mapCenter: google.maps.LatLngLiteral = null, icon?: string) {
    return new Promise<any>((resolve: Function, reject: Function) => {

      if (!this.initMap) {
      this.loadScript().then(() => {
        //TODO first require endpoint

          const el = document.getElementById(this.options.target) as HTMLElement;

          el && (this.map = new google.maps.Map(el, this.options.mapOptions));

          this.initMap = true;

          if (mapCenter) {
            this.map.setCenter(mapCenter);
          }

          this.newMarkerClusterer(icon);
          resolve();
        }).catch(() => {
          reject();
        });
      } else {
        resolve();
      }
    });
  }

  newMarkerClusterer(icon: string) {
    if (icon) {
      const markerIcon = new google.maps.MarkerImage(icon, new google.maps.Size(74, 90));
      new google.maps.Marker({
        position: this.map.getCenter(),
        map: this.map,
        icon: markerIcon,
      });
    } else {
      this.markerClusterer = new MarkerClusterer(this.map, null, this.options.clusterOptions);
    }
  }
}

